import React, { useCallback, useEffect, useState } from "react";
import {
  ScheduleSharp,
  Send,
  Assignment,
  Description,
} from "@material-ui/icons";
import { Tooltip, IconButton } from "@material-ui/core/";
import Alert from "react-s-alert";
/********** COMPONENTS **********/
import LoadingSpinner from "component/LoadingSpinner";
import AlertElement from "component/AlertElement";
import NotAuthorized from "common/NotAuthorized";
import PackageDetail from "./PackageDetail";
import Footer from "page/Home/Footer2";
import Table from "component/Table";
/********** SERVICES **********/
import ApiServices from "service/ApiServices";
import { functions } from "constant";
/********** STYLES **********/
import { useStyles } from "./style";

export default function PaquetesEnviados(props) {
  /********** VARIABLES **********/
  const classes = useStyles();
  const dataOp = props.dataOp;
  const controller = "paquetesDeAfiliacionYAdhesion";
  const [elementAlertModal, setElementAlertModal] = useState({
    openAlert: false,
      titleAlert: "",
      typeAlert: "",
    }),
    [loadingSpinner, setLoadingSpinner] = useState({
      openLoading: false,
      message: "",
    }),
    [openPackageDetail, setOpenPackageDetail] = useState(false),
    [openAlertModal, setOpenAlertModal] = useState(false),
    [detailPackage, setDetailPackage] = useState([]),
    [authorized, setAuthorized] = useState(true),
    [infoPackage, setInfoPackage] = useState([]),
    [data, setData] = useState([]),
    [tableOptions] = useState({
      pageSize: 20,
      filtering: true,
      pageSizeOptions: [20, 30, 50, 75, 100],
      toolbar: true,
      paging: true,
      search: true,
      actionsColumnIndex: -1,
    }),
    [tableHeader] = useState([
      {
        title: "Identificador del paquete",
        field: "id",
        cellStyle: { width: "100px", height: "50px" },
      },
      { title: "Nombre del paquete", field: "name" },
      { title: "Hojas en el paquete", field: "totalHojas" },
      { title: "Fecha de creacion", field: "fechaCreacionParseada" },
      { title: "Fecha de envío", field: "fechaEnviado" },
      { title: "Fecha de recepción", field: "fechaRecibido" },
      {
        title: "Estado",
        field: "estado",
        filtering: false,
        render: (rowData) => (
          <div style={{ minWidth: "200px" }}>
            {rowData.idEstadoPaquete === 2 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ScheduleSharp style={{ color: "#5dade2" }} /> RECIBIDO
              </div>
            ) : rowData.idEstadoPaquete === 3 ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Assignment style={{ color: "#5dade2" }} /> EN DEPURACIÓN
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Send style={{ color: "#5dade2" }} /> ENVIADO
              </div>
            )}
          </div>
        ),
      },
      {
        title: "Acciones",
        field: "acciones",
        filtering: false,
        render: (rowData) => (
          <div
            className={classes.actionContainer}
            style={{ minWidth: "200px" }}
          >
            <div className={classes.iconButtonContainer}>
              <Tooltip
                title="Detalle Paquete"
                onClick={() =>
                  showPackageModal(rowData)
                }
              >
                <IconButton
                  className={classes.iconStyles}
                  size="small"
                  color="primary"
                >
                  <Description />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        ),
      },
      {
        title: "Documentos",
        field: "archivo",
        filtering: false,
        render: (rowData) => (
          <div style={{ minWidth: "200px" }}>
            <Tooltip title="Constancia de Envío">
              <IconButton
                size="small"
                color="primary"
                onClick={() => dowloadDocument(rowData)}
              >
                <img
                  alt="dowload"
                  style={{ height: 40, width: 40 }}
                  src="/assets/constancia_dowload.svg"
                />
              </IconButton>
            </Tooltip>
          </div>
        ),
      },
    ]);

  /********** FUNCTIONS **********/
  /*  Este método lista la información de los paquetes desde el estado 1 al 3 y que sean de faseOP 2 - Comite
        se ejecuta en el useEffect y en el "refreshList"   */
  const showList = useCallback(async () => {
    setLoadingSpinner({
      ...loadingSpinner,
      openLoading: true,
      message: "Obteniendo paquetes enviados...",
    });
    try {
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "list"
      );
      if (hasPermission.error) {
        setAuthorized(false);
        Alert.warning("Permisos Insuficientes");
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      } else {
        let response = await ApiServices[controller].getListPackageOp(
          dataOp.idOrganizacion,
          2,
          2
        );
        let data = [];
        if (response.error !== null) {
          setElementAlertModal({
            openAlert: true,
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          data = response.data;

          data.forEach((value) => {
            value.movimientos.reduce((acc, movimiento) => {
              switch (movimiento.idEstadoPaquete) {
                case 0:
                  if (!acc.fechaCreacionParseada) {
                    acc.fechaCreacionParseada =
                      movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
                case 1:
                  if (!acc.fechaEnviado) {
                    acc.fechaEnviado = movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
                case 2:
                  if (!acc.fechaRecibido) {
                    acc.fechaRecibido = movimiento.fechaYHoraMovimientoParseada;
                  }
                  break;
              }
              return acc;
            }, value);
          });
          setData(data);
        }
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: false,
      });
    }
  }, []);

  useEffect(() => {
    showList();
  }, [showList]);

  /*  Este método despliega el modal "PackageDetail" que contiene la informacion detallada del paquete que seleccionemos, se ejecuta desde el botón
        "Detalle Paquete" en la fila de cada paquete de la tabla */
  const showPackageModal = (rowData) => {
    setOpenPackageDetail(true);
    setDetailPackage(rowData);
  };

  /*  El método cierra el modal "PackageDetail" se ejecuta desde el mismo componente en el botón "Cancelar" */
  const handleClosePackageModal = () => {
    setOpenPackageDetail(false);
  };

  /*  Este método ejecuta la función para descargar un documento pdf con el cve de cada paquete,
        se ejecuta desde el icono "Constancia de envío" */
  const dowloadDocument = async (data) => {
    var idPackage = data.id;
    try {
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: true,
        message: "Generando documento...",
      });
      const hasPermission = await ApiServices.userSecurity.hasPermission(
        controller,
        "openFile"
      );
      if (hasPermission.error) {
        Alert.warning("Permisos Insuficientes");
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      } else {
        let response =
          await ApiServices.paquetesDeAfiliacionYAdhesion.openConstanciaEnvio(
            idPackage
          );
        if (response.error !== null) {
          setElementAlertModal({
            openAlert: true,
            titleAlert: response.error.message,
            typeAlert: "error",
          });
        } else if (response.data !== "") {
          functions.downloadPDFFromStringBase64(
            response.data,
            "Constancia de Envío del paquete  " + idPackage
          );
        }
        setLoadingSpinner({
          ...loadingSpinner,
          openLoading: false,
        });
      }
    } catch (exception) {
      exception.status === 404
        ? Alert.warning("Intente de nuevo")
        : Alert.warning("Intente de nuevo ");
      setLoadingSpinner({
        ...loadingSpinner,
        openLoading: false,
      });
    }
  };

  /* Este método cierra el modal "AlertElement" de mensajes de alerta */
  const handCloseAlertModal = () => {
    setElementAlertModal({...elementAlertModal, openAlert: false});
  };

  /********** RENDER **********/
  if (!authorized) {
    return <NotAuthorized />;
  }

  return (
    <div>
      {loadingSpinner.openLoading && (
        <LoadingSpinner
          open={loadingSpinner.openLoading}
          message={loadingSpinner.message}
        />
      )}
      {elementAlertModal.openAlert && (
        <AlertElement
          typeAlert={elementAlertModal.typeAlert}
          openModal={elementAlertModal.openAlert}
          title={elementAlertModal.titleAlert}
          handCloseModal={handCloseAlertModal}
        />
      )}
      {openPackageDetail && (
        <PackageDetail
          open={openPackageDetail}
          handCloseModal={handleClosePackageModal}
          data={detailPackage}
        />
      )}
      <Table
        title={"Listado de paquetes enviados"}
        header={tableHeader}
        data={data}
        refreshList={showList}
        options={tableOptions}
      />
      <Footer />
    </div>
  );
}
